import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { Button } from "./ui/button";
import { ArrowRight, Sparkles } from "lucide-react";
import { images } from "../assets/images";
import { BackgroundMedia } from "./BackgroundMedia";

export function ClosingSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });

  return (
    <section
      id="action"
      ref={ref}
      className="relative h-screen w-full flex items-center justify-center overflow-hidden"
    >
      {/* Background Image - 走向日出 */}
      <motion.div
        initial={{ scale: 1.2, opacity: 0 }}
        animate={isInView ? { scale: 1, opacity: 1 } : { scale: 1.2, opacity: 0 }}
        transition={{ duration: 2, ease: "easeOut" }}
        className="absolute inset-0"
      >
        <BackgroundMedia
          videoSrc={images.journey}
          imageSrc={images.journeyImage}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-orange-900/20 to-transparent" />
      </motion.div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-5xl">
        {/* 标题 */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
          transition={{ duration: 1, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
          className="mb-16"
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={isInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.8 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="inline-flex items-center gap-2 px-6 py-3 bg-white/20 backdrop-blur-sm rounded-full mb-8 border border-white/30"
          >
            <Sparkles className="w-5 h-5 text-yellow-300" />
            <span className="text-white text-lg tracking-wide">成为改变的力量</span>
            <Sparkles className="w-5 h-5 text-yellow-300" />
          </motion.div>

          <h2 className="text-white text-3xl md:text-5xl lg:text-6xl mb-6 leading-tight">
            了解如何为战争儿童贡献一份爱心？
          </h2>

          <motion.div
            initial={{ scaleX: 0 }}
            animate={isInView ? { scaleX: 1 } : { scaleX: 0 }}
            transition={{ duration: 1, delay: 0.8 }}
            className="h-1 w-32 bg-white/50 mx-auto"
          />
        </motion.div>

        {/* CTA按钮 */}
        <motion.div
          initial={{ opacity: 0, scale: 0.8, y: 20 }}
          animate={isInView ? { opacity: 1, scale: 1, y: 0 } : { opacity: 0, scale: 0.8, y: 20 }}
          transition={{ duration: 0.8, delay: 1, ease: [0.22, 1, 0.36, 1] }}
        >
          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <Button
              size="lg"
              className="group relative h-20 px-16 text-2xl rounded-full shadow-2xl bg-white text-amber-800 hover:bg-white hover:text-amber-900 transition-all duration-300 overflow-hidden"
              asChild
            >
            <a href="https://greensmartlifestyle.cn" target="_blank" rel="noopener noreferrer">
              {/* 按钮背景动画 */}
              <motion.div
                className="absolute inset-0 bg-gradient-to-r from-yellow-200 to-amber-200 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                animate={{
                  x: ["-100%", "100%"],
                }}
                transition={{
                  duration: 3,
                  repeat: Infinity,
                  ease: "linear",
                }}
              />
              
              <span className="relative z-10 flex items-center gap-4">
                成为联合发起人
                <ArrowRight className="w-7 h-7 group-hover:translate-x-2 transition-transform duration-300" />
              </span>
            </a>
            </Button>
          </motion.div>

          {/* 提示文字 */}
          <motion.p
            initial={{ opacity: 0 }}
            animate={isInView ? { opacity: 1 } : { opacity: 0 }}
            transition={{ duration: 0.8, delay: 1.5 }}
            className="text-white/80 text-lg mt-8"
          >
            点击开启您的公益之旅
          </motion.p>
        </motion.div>
      </div>

      {/* 页脚信息 */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={isInView ? { opacity: 1 } : { opacity: 0 }}
        transition={{ duration: 1, delay: 2.2 }}
        className="absolute bottom-8 left-0 right-0 text-center"
      >
        <p className="text-white/50 text-sm tracking-widest">
          CLAIM COFFEE · WHITE DOVE ACTION · 2024
        </p>
      </motion.div>
    </section>
  );
}

